(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  (function(){
    /**
     * Handles toggling the navigation menu for small screens.
     */
    var container, button, menu;
    //container = document.getElementById('site-navigation');
    //header = container.closest('.site-header');
    container = document.querySelector('.site-header');
    if (!container) return;
    button = document.getElementById('site-navigation-toggle');
    if (!button) return;
    menu = container.querySelector('#site-navigation .menu');
    if (!menu) {
      button.style.display = 'none';
      return;
    }

    menu.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function(e){
      let menu_items = document.querySelectorAll('.menu-item-has-children');
      // if "mobile-expanded" class is present
      if (-1 !== container.className.indexOf('mobile-expanded')) {
        container.className = container.className.replace(' mobile-expanded', '');
        button.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-expanded', 'false');
        // close any open submenus too
        for (let item of menu_items) {
          if (-1 !== item.className.indexOf('open')) {
            item.className = item.className.replace(' open', '');
            item.querySelector('.sub-menu__list').setAttribute('aria-expanded', 'false');
          }
        }
      } else {
        container.className += ' mobile-expanded';
        button.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-expanded', 'true');
      }
    }, false);

  })();

}));
